module.exports = __webpack_public_path__ + "static/media/Poppins-Bold.db3867ea.woff";